import { UserAction } from '../UserAction';

type TTableRowUpdate = {
  updated_at?: string | null;
  updated_by?: string | null;
  created_at?: string;
  created_by?: string;
};
type TTableRowProp<T extends TTableRowUpdate> = {
  item: T;
};

const DATE_FORMAT = 'dd/MM/yyyy HH:mm';

export function TableUpdatedBy<T extends TTableRowUpdate>({ item }: TTableRowProp<T>) {
  return item.updated_at ? (
    <UserAction
      id={item.updated_by ?? undefined}
      timestamp={item.updated_at}
      formatZ={DATE_FORMAT}
    />
  ) : (
    <UserAction id={item.created_by} timestamp={item.created_at} formatZ={DATE_FORMAT} />
  );
}
